import { z } from 'zod';
import { addIssue } from './add-issue';

export const validateOperationHours = (
  operationHoursRange: any,
  weekPeriod: string,
  basePath: Array<string | number>,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
): boolean => {
  let hasErrors = false;
  const openingTime = operationHoursRange?.[weekPeriod]?.openingTime;
  const closingTime = operationHoursRange?.[weekPeriod]?.closingTime;

  if (!openingTime || openingTime.length !== 4) {
    addIssue(ctx, [...basePath, 'operationHoursRange', weekPeriod, 'openingTime'], 'Horário de abertura inválido');
    hasErrors = true;
  }

  if (!closingTime || closingTime.length !== 4) {
    addIssue(ctx, [...basePath, 'operationHoursRange', weekPeriod, 'closingTime'], 'Horário de fechamento inválido');
    hasErrors = true;
  }

  if (openingTime && closingTime && Number(openingTime) >= Number(closingTime)) {
    addIssue(
      ctx,
      [...basePath, 'operationHoursRange', weekPeriod, 'closingTime'],
      'Horário de fechamento deve ser maior que o horário de abertura',
    );
    hasErrors = true;
  }

  return !hasErrors;
};
